<template>
  <div class="cc-check-box">
    <el-checkbox
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      @change="handleCheckAllChange"
      style="margin-right:30px"
      :disabled="disabled || checkDisabled"
      >全选</el-checkbox
    >
    <el-checkbox-group
      :value="value"
      @input="handleInput"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="item in options"
        :label="item.value"
        :key="item.value"
        :disabled="item.disabled || disabled"
        >{{ item.label }}</el-checkbox
      >
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array
    },
    value: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkAll: false
      // isIndeterminate: false
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue.length === 0) {
        this.checkAll = false
      } else {
        this.checkAll = newValue.length === this.options.map(item => item.value).length
      }
    }
  },
  computed: {
    isIndeterminate() {
      let checkedCount = this.value.length
      return checkedCount > 0 && checkedCount < this.options.length
    }
  },
  methods: {
    handleCheckAllChange(val) {
      const value = val ? this.options.map(item => item.value) : []
      this.$emit('input', value)
      this.$emit('checked', true)
    },
    handleInput(val) {
      const checkedItmes = val
      this.$emit('input', checkedItmes)
      this.$emit('checked', true)
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.options.length
    }
  },
  created() {
    if (this.value && this.value.length > 0) {
      this.checkAll = this.value.length === this.options.map(item => item.value).length
    }
  }
}
</script>

<style lang="stylus" scoped>
.cc-check-box
  display flex
</style>
